
/* eslint-disable */

if (process.env.NODE_ENV !== 'development') {

  (function (w) {
    var s = document.createElement('script')
    s.src = 'https://survey.survicate.com/workspaces/9cd0d9cb3823f32f6cb3492eb6e7d1e4/web_surveys.js'
    s.async = true
    var e = document.getElementsByTagName('script')[0]
    e.parentNode.insertBefore(s, e)
  })(window)
}

/* eslint-enable */
